import banana from "../../assets/games/tower-game/tower-items/banana.png";
import boiledEgg from "../../assets/games/tower-game/tower-items/boiled-egg.png";
import oatmeal from "../../assets/games/tower-game/tower-items/oatmeal.png";
import water from "../../assets/games/tower-game/tower-items/water.png";
import brownRice from "../../assets/games/tower-game/tower-items/brown-rice.png";
import blueberries from "../../assets/games/tower-game/tower-items/blueberries.png";
import spinach from "../../assets/games/tower-game/tower-items/spinach.png";
import carrot from "../../assets/games/tower-game/tower-items/carrot.png";
import tomato from "../../assets/games/tower-game/tower-items/tomato.png";
import bellPepper from "../../assets/games/tower-game/tower-items/bell-pepper.png";
import soda from "../../assets/games/tower-game/tower-items/soda.png";
import donuts from "../../assets/games/tower-game/tower-items/donuts.png";
import chips from "../../assets/games/tower-game/tower-items/chips.png";
import cakeWithFrosting from "../../assets/games/tower-game/tower-items/cake-with-frosting.png";
import icecreamSundae from "../../assets/games/tower-game/tower-items/icecream-sundae.png";

import plainPopcorn from "../../assets/games/tower-game/tower-items/plain-popcorn.png";
import freshFruitSalad from "../../assets/games/tower-game/tower-items/fresh-fruit-salad.png";
import plainGreekYogurt from "../../assets/games/tower-game/tower-items/plain-greek-yogurt.png";
import unsaltedNuts from "../../assets/games/tower-game/tower-items/unsalted-nuts.png";
import wholeGrainToast from "../../assets/games/tower-game/tower-items/whole-grain-toast.png";
import wholeWheatPancakeFruit from "../../assets/games/tower-game/tower-items/whole-wheat-pancake-fruit.png";
import zucchiniNoodles from "../../assets/games/tower-game/tower-items/zucchini-noodles.png";
import roastedChickpeas from "../../assets/games/tower-game/tower-items/roasted-chickpeas.png";
import radishes from "../../assets/games/tower-game/tower-items/radishes.png";
import puffedBrownRice from "../../assets/games/tower-game/tower-items/puffed-brown-rice.png";
import butterPopcorn from "../../assets/games/tower-game/tower-items/butter-popcorn.png";
import cannedFruitSyrup from "../../assets/games/tower-game/tower-items/canned-fruit-syrup.png";
import flavoredSweetenedYogurt from "../../assets/games/tower-game/tower-items/flavored-sweetened-yogurt.png";
import honeyRoastedNuts from "../../assets/games/tower-game/tower-items/honey-roasted-nuts.png";
import whiteBreadToast from "../../assets/games/tower-game/tower-items/white-bread-toast.png";

import darkChocolate70 from "../../assets/games/tower-game/tower-items/dark-chocolate-70.png";
import ovenBakedFish from "../../assets/games/tower-game/tower-items/oven-baked-fish.png";
import appleNutButter from "../../assets/games/tower-game/tower-items/apple-nut-butter.png";
import bakedZucchiniFries from "../../assets/games/tower-game/tower-items/baked-zucchini-fries.png";
import avocado from "../../assets/games/tower-game/tower-items/avocado.png";
import olives from "../../assets/games/tower-game/tower-items/olives.png";
import tofu from "../../assets/games/tower-game/tower-items/tofu.png";
import steelCutOatmealBerries from "../../assets/games/tower-game/tower-items/steel-cut-oatmeal-berries.png";
import edamame from "../../assets/games/tower-game/tower-items/edamame.png";
import dragonFruit from "../../assets/games/tower-game/tower-items/dragon-fruit.png";
import milkChocolate from "../../assets/games/tower-game/tower-items/milk-chocolate.png";
import friedFishSticks from "../../assets/games/tower-game/tower-items/fried-fish-sticks.png";
import appleCaramel from "../../assets/games/tower-game/tower-items/apple-caramel.png";
import friedZucchiniFries from "../../assets/games/tower-game/tower-items/fried-zucchini-fries.png";
import butter from "../../assets/games/tower-game/tower-items/butter.png";

const towerItemsImagesObj = {
  banana,
  boiledEgg,
  oatmeal,
  water,
  brownRice,
  blueberries,
  spinach,
  carrot,
  tomato,
  bellPepper,
  soda,
  donuts,
  chips,
  cakeWithFrosting,
  icecreamSundae,
  plainPopcorn,
  freshFruitSalad,
  plainGreekYogurt,
  unsaltedNuts,
  wholeGrainToast,
  wholeWheatPancakeFruit,
  zucchiniNoodles,
  roastedChickpeas,
  radishes,
  puffedBrownRice,
  butterPopcorn,
  cannedFruitSyrup,
  flavoredSweetenedYogurt,
  honeyRoastedNuts,
  whiteBreadToast,
  darkChocolate70,
  ovenBakedFish,
  appleNutButter,
  bakedZucchiniFries,
  avocado,
  olives,
  tofu,
  steelCutOatmealBerries,
  edamame,
  dragonFruit,
  milkChocolate,
  friedFishSticks,
  appleCaramel,
  friedZucchiniFries,
  butter,
};

export default towerItemsImagesObj;
